// 判断文件名是否为 macOS 写到非 APFS/HFS+ 文件系统（NAS via SMB/AFP/NFS、FAT/exFAT 等）
// 时产生的元数据副产物：
// - `._<name>`：AppleDouble 文件，存放原文件的 resource fork + 扩展属性（Finder 标签/图标/quarantine 等）
// - `.DS_Store`：Finder 目录显示设置
// 这类文件不是业务产物（如 DaVinci 渲染产物），枚举 NAS 目录登记 biz_file、
// 以及 rclone 传输到对象存储时都应排除，避免把 `._xxx.mov` 误当媒体文件送进转码。
// 纯字符串实现（不依赖 node:path），浏览器与 node 两侧均可安全使用。
// 入参应为裸文件名（basename），不含目录。
export const isMacosMetadataFile = (name: string): boolean => name.startsWith('._') || name === '.DS_Store'
